import React, { useCallback, useState } from "react";
import { SelectManager } from "../../selectors/managers/selectManager";
import { RadioGroup } from "../../ui/RadioGroup";
import { SubHeadWithButton } from "../../ui/subHeadWithButton";
import { IndividualForm } from "./individualForm";
import { CorporateUBOForm } from "./corporateForm";
import { diligenceObservable } from "../../../observers/deligenceObservable";
import { Input } from "../../ui/Input";

export const ManagerForm = React.memo(({renderBy, index, manager, onChange, handleIndividualChange, handleUBOChange, onRemove, isReadOnly, isReport}) => {

    const [hide, setHide] = useState(true);

    const handleToggle = useCallback(() => {
        setHide(prev => !prev);
    }, []);

    return (
        <div key={index} className="manager-section">
            <SubHeadWithButton 
                isReport={isReport}
                heading={`Manager ${index}`}
                buttons={
                    [
                        { buttonText: hide ? "-" : "+", onClick: handleToggle },
                        { buttonText: "x", onClick: () => { if (!isReadOnly) {onRemove(); diligenceObservable.removeByPrefix(renderBy+index.toString())} }, style: {backgroundColor: isReadOnly ? "#ccc" : "red", color: "white"} }
                    ]}
            />
            {hide && (
                <form>
                <SelectManager 
                    label={"Manager Function"}
                    name={"managerType"}
                    disabled={isReadOnly}
                    value={manager.managerType}
                    onChange={onChange}
                    required={true}
                    isReport={isReport}
                />


                 {(manager.managerType === "Other") && (
                            <Input
                                label="Describe Manager Function"
                                type="text"
                                name="functionDetail"
                                value={manager.functionDetail}
                                onChange={onChange}
                                isReport={isReport}
                                />
                            )}

                <RadioGroup 
                    label={"Is this manager an individual or corporate entity?"}
                    name={"managerEntity"}
                    value={manager.managerEntity}
                    disabled={isReadOnly}
                    onChange={onChange}
                    isReport={isReport}
                    options={[
                        { value: "Individual", display_value: "Individual" },
                        { value: "Corporate", display_value: "Corporate" }
                    ]}
                />

                {manager.managerEntity === "Individual" && (
                    <IndividualForm
                        isReadOnly={isReadOnly}
                        formData={manager.data}
                        onChange={handleIndividualChange}
                        isReport={isReport}
                    />
                )}

                {manager.managerEntity === "Corporate" && (
                    <CorporateUBOForm
                        renderBy={renderBy}
                        index={index}
                        isReadOnly={isReadOnly}
                        initialData={manager.data.uboState}
                        onUpdate={handleUBOChange}
                        isReport={isReport}
                    />
                )}
            </form>
            )}
        </div>
    );
});

export const MemoizedManagerForm = React.memo(ManagerForm, (prevProps, nextProps)=> {
    return (
        prevProps.manager.id === nextProps.manager.id &&
        prevProps.isReadOnly === nextProps.isReadOnly &&
        JSON.stringify(prevProps.manager) === JSON.stringify(nextProps.manager) &&
        prevProps.onRemove === nextProps.onRemove &&
        prevProps.index === nextProps.index &&
        prevProps.isReport === nextProps.isReport
    );
});